export const CONTACT = {
  company: "MARTIN NETTOYAGE",
  slogan: "Vite compris, vite restauré.",
  phone: "06 78 10 77 71",
  phoneHref: "tel:0678107771",
  email: "christophe.martin0307@gmail.com",
  quoteEmail: "devis@martinnettoyage.com",
  area: "Belfort / Montbéliard / Héricourt",
};

export const IMAGES = {
  autoCard: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  habitatCard: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/77583dd025209bec19779a5f85823cef09829de16b4c51b5f737e3803f2a65ac.png",
  autoInterior: "https://images.pexels.com/photos/31389821/pexels-photo-31389821.jpeg?auto=compress&cs=tinysrgb&w=1200",
  facade: "https://images.unsplash.com/photo-1494177242659-c726060f48dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const BEFORE_AFTER = [
  {
    id: "terrace",
    label: "Restauration de terrasse bois",
    category: "Habitat",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/dcc82696fe831b2764a574375eb4f79a2d62c9aaa3676d31a773876a0509545f.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/641e2ad2921cf40296f88cae6bb3503b18dc3f29ad00cd2944b99a49d8f42a79.png",
    quote: "Ma terrasse a retrouvé sa couleur d'origine. Bluffant.",
    author: "Marc D., Montbéliard",
  },
  {
    id: "facade",
    label: "Nettoyage de façade",
    category: "Habitat",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/cc370ddb9eb631653e72e491da06c4e310f4aa0612142f6b26273d277996f9fa.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/77583dd025209bec19779a5f85823cef09829de16b4c51b5f737e3803f2a65ac.png",
    quote: "Façade comme repeinte à neuf, les traces noires ont disparu.",
    author: "Nadia B., Héricourt",
  },
  {
    id: "allee",
    label: "Nettoyage d'allée & cour",
    category: "Habitat",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/50cb73cde5341e604215dbc7f2d1f8f8d3a369a895fafc23c8343771f627dbf5.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/4a6bdf1d940c9552ae99dbdcabfe0b0cda90ab9eab5fe58c0bd1707546768592.png",
    quote: "Mon allée est méconnaissable, plus aucune mousse. Parfait.",
    author: "Thierry L., Montbéliard",
  },
  {
    id: "car",
    label: "Detailing & protection céramique",
    category: "Auto",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/604bc592d61e48d6072da0a5e3eee80b1bd50d1d11e935f2ddf5cd63bb5eaaf5.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/df9ac35e4cf28b7a7b54e5fd9d142b5c6f6f88ac56c2759498809da3e9bd302a.png",
    quote: "Carrosserie comme neuve, brillance incroyable après le passage.",
    author: "Julien P., Belfort",
  },
  {
    id: "interior-front",
    label: "Intérieur — sièges avant & tableau de bord",
    category: "Auto",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/208f555a622a475f02c37ea5fb38e53ed791fd134b90ba77771cc0b258c7082e.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/70ef1e3bf6fe0c98201120eaa3b1abbcc6be26d46ad99b07d44bbb6479b09b8d.png",
    quote: "Habitacle comme neuf, tableau de bord et sièges impeccables.",
    author: "Sophie L., Belfort",
  },
  {
    id: "interior-rear",
    label: "Intérieur — shampooing sièges",
    category: "Auto",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/b16114e028e0ae1d2a65d1c863d6cf818f48b6e81e4f2702ed3900d08e0b9182.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/17bd382ae7f37c06699841d9ebe9ec016f2b75ab58371b904f128d63e4abf3fc.png",
    quote: "Les taches sur les sièges arrière ont totalement disparu. Bluffant.",
    author: "Karim Z., Montbéliard",
  },
  {
    id: "fullcar",
    label: "SUV blanc — lavage complet",
    category: "Auto",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/0f2182a4bb26bfe5738f9b1da923619718f8a34e06cb9cbfa7bac94a95fe392e.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/16cd78b73688a2d2dd599627c1569fcddd2f7cd6858c9ff7f5d6c35869ca0ddb.png",
    quote: "Voiture repartie comme neuve après une sortie boueuse. Nickel !",
    author: "Kevin M., Belfort",
  },
  {
    id: "sedan",
    label: "Berline premium",
    category: "Auto",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/f7497208f09b1077bf1fe844c1e175d562cd7c984af8fba1b12f1cecc10a47e7.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/201abf98bfab9f2f3b8bd3f4de445c96b0d5fbfa4d80b1a064c7193612fe265d.png",
    quote: "Ma berline noire brille comme jamais, un vrai lustrage de pro.",
    author: "Damien F., Montbéliard",
  },
  {
    id: "hatch",
    label: "Compacte premium",
    category: "Auto",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/03f00605890d2fe6724bd74279b863f75458097b75f53ffabeb304e238493d38.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/454352741e8bddac0f871416b70ae4d37b8f3b3ffc7cb0d8218688686a577945.png",
    quote: "Lavage extérieur impeccable, plus une trace de boue. Rapide et net.",
    author: "Laura B., Belfort",
  },
  {
    id: "suv",
    label: "SUV familial",
    category: "Auto",
    before: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/86132e0eba3a8e4ca6a60820daacc1033d21f2b3f0ba9a393dcb0a3679a13108.png",
    after: "https://static.prod-images.emergentagent.com/jobs/877c6a23-ea34-4c44-bcad-04f4869b2517/images/57a0da157a328c52dca21fc059e8ee35316f1d009a9a66fe67f8c61f789a4920.png",
    quote: "Mon SUV a retrouvé tout son éclat, même les jantes. Parfait.",
    author: "Olivier T., Héricourt",
  },
];
